module.exports = __webpack_public_path__ + "static/images/homeicon5.3e87b19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/homeicon5.png
// module id = yzb2
// module chunks = 0